import actions from './actions';
import mutations from './mutations';

function state() {
    return {
        url: null,
        videoData: {
            code: null,
            image: null,
            title: null
        },
        isLoading: null
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};